import instObj from '@/backend/axios-instances'

const resource = "/accounts"
const instance = instObj.baseInstance

export default {
  get(parameters) {
    return instance.get(resource, { params: parameters });
  }
}
